// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"395":"21ac5281","629":"544392e1"}[chunkId] + ".chunk.js";
};